var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBxMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0007 45.834L34.6673 40.5007V26.7887C39.2567 25.5967 42.6673 21.4553 42.6673 16.5007C42.6673 10.618 37.8833 5.83398 32.0007 5.83398C26.118 5.83398 21.334 10.618 21.334 16.5007C21.334 21.4553 24.7447 25.5967 29.334 26.7887V40.5007L32.0007 45.834ZM26.6673 16.5007C26.6673 13.5593 29.0593 11.1673 32.0007 11.1673C34.942 11.1673 37.334 13.5593 37.334 16.5007C37.334 19.442 34.942 21.834 32.0007 21.834C29.0593 21.834 26.6673 19.442 26.6673 16.5007Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3793 28.6687L41.958 33.81C48.8673 35.7193 53.334 39.3913 53.334 43.1673C53.334 48.2127 44.574 53.834 32.0007 53.834C19.4273 53.834 10.6673 48.2127 10.6673 43.1673C10.6673 39.3913 15.134 35.7193 22.046 33.8073L20.6247 28.666C11.1927 31.274 5.33398 36.8287 5.33398 43.1673C5.33398 52.138 17.0487 59.1673 32.0007 59.1673C46.9527 59.1673 58.6673 52.138 58.6673 43.1673C58.6673 36.8287 52.8087 31.274 43.3793 28.6687Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxMapPin);
export default __webpack_public_path__ + "static/media/bx-map-pin.494e87a2b5e357d8144083eb9daee77c.svg";
export { ForwardRef as ReactComponent };